<template>
  <div :class="$style.overlay" v-if="isVisible">
    <div :class="$style.adminAssignmentHistoryRep">
      <b :class="$style.title">History Report</b>
      <div :class="$style.submittedBy">
        <b :class="$style.text">Submitted by Tyler Johnson</b>
        <div :class="$style.date">Feb 21</div>
        <div :class="$style.scoreParent">
          <div :class="$style.scoreContainer">
            <span>
              <b>Score</b>
              <span :class="$style.span"> - </span>
            </span>
            <b :class="$style.b">67%</b>
          </div>
          <div :class="$style.correctContainer">
            <b>Correct</b>
            <span :class="$style.span1"> - 2</span>
          </div>
          <div :class="$style.incorrectContainer">
            <b>Incorrect</b>
            <span :class="$style.span1"> - 1</span>
          </div>
        </div>
      </div>
      <hr :class="$style.dividerLine" />
      <div :class="$style.changeLogParent">
        <b :class="$style.text">Admin Change - JR McLaws </b>
        <div :class="$style.date">Feb 22</div>
        <div :class="$style.text">
          <p :class="$style.changeLogReason">Changed Question 3 to correct.</p>
          <p :class="$style.changeLogReason">&nbsp;</p>
          <p :class="$style.changeLogReason">
            <b :class="$style.span">Initial Response</b>
            <span :class="$style.changeLogDescription">
              - A Third-Class Medical Certificate is required for private
              pilots,
            </span>
          </p>
          <p :class="$style.changeLogReason">
            issued by an FAA-authorized Aviation Medical Examiner (AME)
          </p>
          <p :class="$style.changeLogReason">&nbsp;</p>
          <p :class="$style.resultingChange">
            <b>Resulting Change:</b>
          </p>
        </div>
        <div :class="$style.scoreParent">
          <div :class="$style.scoreContainer">
            <span>
              <b>Score</b>
              <span :class="$style.span"> - </span>
            </span>
            <b :class="$style.b1">100%</b>
          </div>
          <div :class="$style.correctContainer">
            <b>Correct</b>
            <span :class="$style.span1"> - 3</span>
          </div>
          <div :class="$style.incorrectContainer">
            <b>Incorrect</b>
            <span :class="$style.span1"> - 0</span>
          </div>
        </div>
      </div>
      <button @click="closeModal" :class="$style.closeWrapper">
        <b :class="$style.close">Close</b>
      </button>
      <!--      <div :class="$style.closeWrapper">
        <b :class="$style.close">Close</b>
      </div>-->
      <img
        @click="closeModal"
        :class="$style.vectorIcon"
        alt=""
        src="/static/img/grey-x.svg"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "AdminAssignmentHistoryRep",
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>
<style module scoped>
.title {
  position: relative;
  font-size: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  z-index: 0;
}
.text {
  position: relative;
}
.date {
  position: relative;
  font-size: 15px;
  color: rgba(64, 64, 64, 0.5);
}
.span {
  font-family: Helvetica, Arial, sans-serif;
}
.b {
  color: #f56e08;
}
.scoreContainer {
  align-self: stretch;
  width: 186.7px;
  position: relative;
  display: inline-block;
  flex-shrink: 0;
}
.span1 {
  color: #404040;
}
.correctContainer {
  align-self: stretch;
  flex: 1;
  position: relative;
  color: #0c974f;
}
.incorrectContainer {
  align-self: stretch;
  flex: 1;
  position: relative;
  color: #ba0000;
}
.scoreParent {
  align-self: stretch;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 10px 10px 10px 0px;
  gap: 10px;
}
.submittedBy {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  z-index: 1;
}
.adminAssignmentHistoryRepChild {
  align-self: stretch;
  position: relative;
  max-width: 100%;
  overflow: hidden;
  max-height: 100%;
  z-index: 2;
}
.changeLogReason {
  margin: 0;
}
.changeLogDescription {
  white-space: pre-wrap;
}
.resultingChange {
  margin: 0;
  white-space: pre-wrap;
}
.b1 {
  color: #0c974f;
}
.changeLogParent {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  z-index: 3;
}
.adminAssignmentHistoryRepItem {
  align-self: stretch;
  position: relative;
  max-width: 100%;
  overflow: hidden;
  max-height: 100%;
  z-index: 4;
}
.close {
  position: relative;
  display: -webkit-inline-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.closeWrapper {
  align-self: stretch;
  border-radius: 5px;
  background-color: #3171e2;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  z-index: 5;
  text-align: center;
  color: #fff;
  border: none;
}
.vectorIcon {
  width: 12px;
  position: absolute;
  margin: 0 !important;
  top: 39px;
  right: 51px;
  height: 12px;
  z-index: 6;
  cursor: pointer;
}
.adminAssignmentHistoryRep {
  width: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 30px;
  box-sizing: border-box;
  gap: 20px;
  text-align: left;
  font-size: 18px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
}
.overlay {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 50;
}

.dividerLine {
  border: 0;
  border-top: 1px solid #ddd;
  height: 0;
  margin: 5px 0;
  width: 100%;
  box-sizing: border-box;
}
</style>
